import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { InformationFlow } from '@ifeng-fe/three_terminal/es/mobile/informationFlow/index.js';
import { Comment, ShareComment } from '@ifeng-fe/three_terminal/es/mobile/comment/index.js';
import { h5PageCount } from '@ifeng-fe/three_terminal/es/utils/h5PageCount.js';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Slider from '../../../lib/react-slick.min.js';
import '../../../lib/slick/slick.css';
import '../../../lib/slick/slick-theme.css';
import Grounds from '@ifeng-fe/three_terminal/es/base/grounds';
import { getCommentCount } from '../../../../services/api';
import { callApp } from '@ifeng-fe/callapp';
const inApp = typeof window !== 'undefined' && window.grounds;

// 专题链接类型转换
export const reLocation = (url) => {
    if (typeof location === 'undefined') return url;

    const path = /\/c\/((specialClient)|(special)|(vivo)|(s))\//;
    const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;

    if (/\/c\/s\//.test(location.href)) {
        return url
            .replace(path, '/c/s/')
            .replace('v.ifeng.com/c/', 'ishare.ifeng.com/c/s/')
            .replace('auto.ifeng.com/c/', 'ishare.ifeng.com/c/s/')
            .replace('i.ifeng.com/c/', 'ishare.ifeng.com/c/s/')
            .replace('/s/s/', '/s/');
    }

    if (/\/c\/vivo\//.test(location.href)) return url.replace(path, '/c/vivo/');

    if (/\/c\/special\//.test(location.href)) return url.replace(path, '/c/special/');

    if (/\/c\/specialClient\//.test(location.href)) return url.replace(path, '/c/specialClient/');

    if (isVideoShare) return `https://ishare.ifeng.com/c/vs/${url.split('/').pop()}`;

    return url;
};

const UnfoldMore = function UnfoldMore({ text, onClick, mask }) {
    return (
        <div onClick={onClick} className={styles.unfoldMore}>
            {mask ? <div className={styles.unfoldMore_mask} /> : null}
            <span>{text || '展开全部'}</span>
            <img src={require('../assets/more.png')} alt="" />
        </div>
    );
};

UnfoldMore.propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func,
    mask: PropTypes.bool,
};

export const SubTitle = function SubTitle({ content }) {
    if (content.title === '') {
        return null;
    }

    return (
        <div className={styles.subTitleBox}>
            <div className={styles.subTitle_num}>
                {content.moduleIndex < 10 ? `0${content.moduleIndex}` : content.moduleIndex}
            </div>
            <div className={styles.subTitle}>{content.title}</div>
            {/* {content.subTitleAd && content.subTitleAd.data && content.isShare ? (
                <a className={styles.subTitleAd} href={content.subTitleAd.data.url}>
                    <img src={content.subTitleAd.data.img} alt="" />
                </a>
            ) : null} */}
        </div>
    );
};

export const TimeLine = function TimeLine({ content, allData }) {
    const [fold, toggleFold] = useState(!!content.isFold);
    const [list, changeList] = useState(content.data);
    const [sortState, toggleSort] = useState(
        new Date(content.data[0].moment).valueOf() - new Date(content.data[content.data.length - 1].moment).valueOf() >=
            0
            ? 'up'
            : 'down',
    );
    const items = [];
    const Event = ({ item }) => (
        <a
            className={styles.timeline_evnets}
            onClick={() => {
                if (!item.link) return;

                if (inApp) return Grounds.jumpInNative(item.info);

                location.href = reLocation(item.link);
            }}>
            <img src={require('../assets/dot.svg')} />
            <div className={styles.timeline_date}>{item.moment}</div>
            <div className={styles.tiemline_text}>
                <span>
                    {item.summary}
                    {item.link ? <img src={require('../assets/timeline_arrow.png')} alt="" /> : null}
                </span>
            </div>
        </a>
    );

    Event.propTypes = {
        item: PropTypes.object.isRequired,
    };

    let hasFolder = false;

    list.forEach((item, index) => {
        if (index === 4 && fold) {
            hasFolder = true;
        } else if (index < 4 || !fold) {
            items.push(<Event key={index} item={item} />);
        }
    });

    if (hasFolder)
        items.push(
            <UnfoldMore
                onClick={() => {
                    if (allData.isShare) {
                        if (inApp) {
                            Grounds.actionStat({
                                type: 'huigu',
                                id: `special_${allData.docData.base62Id}`,
                                extend: {
                                    kind: 'topic',
                                },
                            });
                        } else {
                            h5PageCount([
                                {
                                    behavior: 'action',
                                    type: 'huigu',
                                    other: {
                                        id: `special_${allData.docData.base62Id}`,
                                        kind: 'topic',
                                    },
                                },
                            ]);
                        }
                    }
                    toggleFold(false);
                }}
                mask={true}
                key={'fold'}
            />,
        );

    return (
        <div className={styles.timeline}>
            <SubTitle content={content} />
            <div
                className={styles.sort}
                onClick={() => {
                    toggleSort(sortState === 'down' ? 'up' : 'down');
                    changeList(list.reverse());
                }}>
                <img src={require(`../assets/arr_${sortState === 'down' ? 'down' : 'up'}.png`)} alt="" />
                {sortState === 'down' ? '倒序' : '正序'}
            </div>
            <div className={styles.timeline_evnets_box}>{items}</div>
        </div>
    );
};

export const Category = function Category(params) {
    const { content, allData } = params;

    // // vivo负一屏添加逻辑 begin
    // if (window.newsRecommandObj && window.newsRecommandObj.onPageContentShow) {
    //     window.newsRecommandObj.onPageContentShow();
    // }

    // vivo负一屏添加逻辑 end
    const News = function News({ item }) {
        item.articleList =
            item.articleList?.map((article) => {
                if (article.url || article.clientUrl) {
                    article.url = article.clientUrl = reLocation(article.url || article.clientUrl);
                }

                if (article.type === 'live') {
                    article.type = 'web';
                }

                return article;
            }) || [];

        const [fold, toggleFold] = useState(item.displayNum < item.articleList.length);

        // console.log(item.articleList);

        const AllNews = () => (
            <InformationFlow
                getVideoPlayNum={false}
                content={item.articleList}
                isDisplayLoadingMore={false}
                isNewsTime={!!item.newsTimeDisplay}
                isFormatTime={true}
            />
        );

        item.title = item.columnName || content.title;
        // item.subTitleAd = allData.docData.ad.firstTitleAd;
        item.isShare = allData.isShare;

        return (
            <div className={styles.category_item}>
                <a name={`flow${item.sequence}`} className={styles.ancher} />
                <a data-type="moduleIndex" name={`moduleIndex_${item.moduleIndex}`} className={styles.ancher} />
                <SubTitle content={item} />
                {fold ? (
                    <InformationFlow
                        getVideoPlayNum={false}
                        content={item.articleList.slice(0, item.displayNum)}
                        isDisplayLoadingMore={false}
                        isNewsTime={!!item.newsTimeDisplay}
                        isFormatTime={true}
                    />
                ) : (
                    <AllNews />
                )}
                {fold ? <UnfoldMore text={'查看更多'} onClick={() => toggleFold(false)} /> : null}
            </div>
        );
    };

    News.propTypes = {
        item: PropTypes.object.isRequired,
    };

    return (
        <div className={styles.category}>
            {content.data.map((item) => (
                <News key={item.columnName} item={item} />
            ))}
        </div>
    );
};

export const ViewPoint = function ViewPoint({ content }) {
    const Point = ({ item }) => {
        return (
            <a href={item.link} className={styles.viewpoint_box}>
                <div className={styles.viewpoint_person}>
                    <div
                        className={styles.viewpoint_person_img}
                        style={{
                            backgroundImage: `url(${item.avatar})`,
                        }}
                    />
                    <div className={styles.viewpoint_person_info}>
                        <div>{item.name}</div>
                        <div>{item.role}</div>
                    </div>
                </div>
                <img className={styles.viewpoint_qt_img} src={require('../assets/quotation_gray_top.svg')} />
                <div className={styles.viewpoint_text}>
                    <span>{item.point}</span>
                </div>
                <img className={styles.viewpoint_qb_img} src={require('../assets/quotation_gray_bottom.svg')} />
            </a>
        );
    };

    Point.propTypes = {
        item: PropTypes.object.isRequired,
    };

    return (
        <div className={styles.viewpoint}>
            <SubTitle content={content} />
            <div className={styles.viewpoint_box_container}>
                {content.data.map((item, index) => (
                    <Point key={index} item={item} />
                ))}
            </div>
        </div>
    );
};

export const PicAd = errorBoundary(({ content, close, adShow, adType }) => {
    let data = content[adType];

    if (!data || !adShow[adType]) return null;
    data = data.data;

    if (!data || !data.img) return null;

    const ThreePic = () =>
        data.img.map((item, index) => {
            return <img className={styles.pic_add_three} src={item} key={index} />;
        });

    const BigPic = ({ url }) => <img className={styles.pic_add_big} src={url} />;

    BigPic.propTypes = {
        url: PropTypes.string,
    };

    return (
        <div className={styles.three_pic_ad}>
            <div className={styles.three_pic_ad_title}>{data.title}</div>
            <div
                className={styles.three_pic_ad_pic}
                onClick={() => {
                    window.location.href = data.url;
                }}>
                {adType === 'threeImagesAd' && <ThreePic />}
                {(adType === 'bigImageAd' || adType === 'bottomAd') && <BigPic url={data.img} />}
            </div>
            <div className={styles.three_pic_ad_gg}>
                <div>广告</div>
                {/* <img src={require('../assets/close.png')} onClick={() => close(adType)} /> */}
            </div>
        </div>
    );
});

export const BottomComment = function BottomComment({ content, allData }) {
    const { base62Id, skey, title, pcUrl, isVideoShare } = allData.docData;
    const { popup } = allData;
    const wxLaunch = (popup && popup.wxLaunch) || {};
    const wxLaunchConfig = {
        wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
        wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
    };
    const wxLaunchType = wxLaunchConfig.wxLaunchType;
    const wxLaunchSwitch = wxLaunchConfig.wxLaunchSwitch;
    const commentDomain =
        typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
    const articleInfo = {
        isVideoShare,
        id: `${base62Id}` || '',
        docUrl: `ucms_${base62Id}` || '', // 文章单页的页面地址
        docTitle: title,
        kind: content.isShare ? 'share52205' : 'df_sf01',
        speUrl: '', // 兼容以后的专题评论
        skey: skey || '',
        pcUrl: pcUrl || '', // 文章pc的页面地址
        cmtNumUrl: `//${commentDomain}/get.php`, // 获取评论内容接口
        cmtLength: 1000, // 评论内容字数长度
        cmtPostUrl: `//${commentDomain}/post.php`, // 提交评论内容接口
        hotLimit: content.isShare ? 3 : 2, // 最热评论数量
        limitHeight: '', // 评论区域的高度限制
        cmtVoteUrl: `//${commentDomain}/vote.php`, // 推荐评论接口
        replyLimit: 3, // 显示回复的楼层
        jubUrl: `//${commentDomain}/report`, // 举报提交接口
        jubNum: 0, // 举报次数，便于每次回调函数名不同
        isComment: false, // 是否是评论详情页面
        allowComment: true, // 是否允许评论
        clickCount: {
            behavior: 'action',
            type: 'comtmore',
            other: {
                ref: `special_ucms_${content.base62Id}`,
                kind: 'topic',
            },
            
        },
        callType: 'topic3',
        downloads: isVideoShare
                ? {}
                : {
                      download: `https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=${
                          content.isShare ? 'CK1354725251042' : 'CK1429035767411'
                      }`,
                      downloadAd: `https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=${
                          content.isShare ? '7641' : '7675'
                      }`,
                  },
        wxLaunchType,
        wxLaunchSwitch,
    };

    return (
        <div className={styles.bottomComment}>
            <SubTitle content={content} />
            {content.topicData.title && <TopicComment content={content} />}
            {content.isShare ? <ShareComment articleInfo={articleInfo} /> : <Comment articleInfo={articleInfo} />}
            {/* <div className={styles.BottomCommentAd}>
                {content.isShare ? (
                    <PicAd content={allData.docData.adData} adShow={{ bottomAd: true }} adType={'bottomAd'} />
                ) : null}
            </div> */}
        </div>
    );
};

export const TopicComment = function TopicComment({ content }) {
    if (!content.data || !content.data[0] || !content.data[0].talkStatus) return null;
    const client = content.isVideoShare ? 'videoApp' : 'newsApp';

    const staticHandler = () => {
        h5PageCount([
            {
                behavior: 'action',
                type: 'huaticlick',
                other: {
                    ref: `special_ucms_${content.base62Id}`,
                    kind: 'topic',
                },
            },
        ]);
        const downloadVal = content.isVideoShare
            ? {}
            : {
                  download: `https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=${
                      content.isShare ? 'CK1354725251042' : 'CK1429035767411'
                  }`,
                  downloadAd: `https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=${
                      content.isShare ? '7641' : '7675'
                  }`,
              };

        callApp({
            client,
            docType: 'topic3',
            pid: content.base62Id,
            kind: `${content.isShare ? 'share01' : 'df_sf01'}`,
            download: downloadVal.download,
            downloadAd: downloadVal.downloadAd,
        });
    };

    const TopicToVote = ({ content }) => {
        const { surveyinfo } = content.topicData.vote;
        const voteData = surveyinfo.result[0].resultArray;

        return (
            <div>
                <div className={styles.Vote_title}>{voteData.question}</div>
                <div className={styles.topicComment_toVote} onClick={() => staticHandler()}>
                    <div>
                        <img src={require('../assets/heart.png')} />
                        <span>{voteData.option[0].title}</span>
                    </div>
                    <div>VS</div>
                    <div>
                        <img src={require('../assets/heart_broken.png')} />
                        <span>{voteData.option[1].title}</span>
                    </div>
                </div>
            </div>
        );
    };

    const VoteResult = ({ content }) => {
        const { handleWxShareClick } = content.commentState;

        return (
            <div className={styles.topicVoteResult}>
                <div className={styles.topicVoteResult_bar_red} style={{ width: '60%' }}>
                    {'60%'}
                </div>
                <div className={styles.topicVoteResult_bar_blue} style={{ width: '40%' }}>
                    {'40%'}
                </div>
                <div className={styles.topicVoteResult_text}>
                    <div>4532人选择非常合理</div>
                    <div>2445人选择有些失望</div>
                </div>
                <div className={styles.topicVoteResult_shareText}>已选择支持方，问问朋友怎么看</div>
                <div className={styles.topicVoteResult_shareIcon}>
                    <img onClick={() => handleWxShareClick('weixin')} src={require('../assets/wx.png')} />
                    <img onClick={() => handleWxShareClick('weixinFriend')} src={require('../assets/wxCircle.png')} />
                </div>
            </div>
        );
    };

    const TopicNoVote = ({ content }) => {
        const { topicData, base62Id } = content;

        return (
            <div className={styles.noVote}>
                <div className={styles.noVote_title}>{content.data[0].talkTitle || topicData.title}</div>
                <div className={styles.noVote_desc}>{topicData.summary}</div>
                <div className={styles.noVote_discuss} onClick={() => staticHandler()}>
                    <div>
                        <img src={require('../assets/users.png')} />与{(topicData.nnum && topicData.nnum.read) || 0}
                        人一起讨论
                        <img src={require('../assets/jiantou.svg')} />
                    </div>
                </div>
            </div>
        );
    };

    const TopicVoteBox = ({ content }) => {
        const { topicData } = content;

        return (
            <div className={styles.topicComment_box}>
                <div className={styles.topicTitle}>
                    <img src={require('../assets/quotation.png')} />
                </div>
                {!topicData.vote ? <TopicNoVote content={content} /> : <TopicToVote content={content} />}
            </div>
        );
    };

    TopicVoteBox.propTypes =
        VoteResult.propTypes =
        TopicToVote.propTypes =
        TopicNoVote.propTypes =
            {
                content: PropTypes.object.isRequired,
            };

    return (
        <div className={styles.topicComment}>
            <TopicVoteBox content={content} />
        </div>
    );
};

const useInterval = function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        const tick = function tick() {
            savedCallback.current();
        };

        if (delay !== null) {
            let id = setInterval(tick, delay);

            return () => clearInterval(id);
        }
    }, [delay]);
};

const NewSlideCard = errorBoundary((params) => {
    const customDots = function customDots(dots) {
        const customDots = dots.map((dot, index) => (
            <div
                key={index}
                className={
                    dot.props.className === 'slick-active'
                        ? styles.newSlideDot_activeStyle
                        : styles.newSlideDot_nomalStyle
                }
            />
        ));

        return <ul className={styles.newSlideDot}> {customDots} </ul>;
    };

    const { content, isShare, isVivo, handleCallUp } = params;
    const [vivoSta, setVivoSta] = useState({});
    const slideVivoSta = (index) => {
        if (isVivo && !vivoSta[index] && typeof location !== 'undefined') {
            h5PageCount([
                {
                    behavior: 'info',
                    type: `national_slide_${index}`,
                    other: {
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
            setVivoSta(Object.assign(vivoSta, { [index]: true }));
        }
    };

    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        appendDots: (dots) => customDots(dots),
        onInit: () => {
            if (content.length) slideVivoSta(0);
        },
        afterChange: (index) => slideVivoSta(index),
    };

    const commentUrls = content.map((item) => item.commentUrl);
    const initCommentState = {};

    commentUrls.forEach((item) => (initCommentState[item] = {}));

    const [comment, setComment] = useState(initCommentState);

    useEffect(() => {
        const getData = async () => {
            const data = await getCommentCount(commentUrls);
            const result = {};

            data.forEach((item) => {
                result[item.doc_url] = item;
            });
            setComment(result);
        };

        getData();
    }, []);

    if (typeof window === 'undefined') return null;

    return (
        <div className={styles.newSlide}>
            <Slider {...settings}>
                {content.map((item, index) => {
                    return (
                        <div
                            key={index}
                            onClick={(e) => {
                                // 阻止父元素a标签跳转
                                e.preventDefault();
                                if (!handleCallUp(e)) {
                                    if (inApp) Grounds.jumpInNative(item);

                                    location.href = reLocation(
                                        isShare && item.type !== 'web' ? item.clientUrl || item.url : item.url,
                                    );
                                }
                            }}>
                            <div className={styles.newSlideItem_box}>
                                <div className={styles.newSlideItem}>
                                    <div
                                        className={styles.img}
                                        style={{
                                            backgroundImage: `url(${item.thumbnail || '../assets/slide_default.png'})`,
                                        }}
                                    />
                                    <div className={styles.newSlideItemMask} />
                                    <div className={styles.newSlideContent}>
                                        <div className={styles.newSlideConten_title}>{item.title || item.summary}</div>
                                        <div className={styles.newSlideConten_source}>
                                            {item.source || item.ESsourceAlias ? (
                                                <span>{item.source || item.ESsourceAlias}</span>
                                            ) : (
                                                ''
                                            )}
                                            {comment[item.commentUrl] && comment[item.commentUrl].join_count ? (
                                                <span>{`${comment[item.commentUrl].join_count}评`}</span>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
});

export const SubTopics = errorBoundary((params) => {
    const { content, handleCallUp, isVivo, isShare } = params;

    if (isVivo || !content.subTopics || !content.subTopics.data.length || !content.subTopics.display) return null;

    const data = content.subTopics.data;

    return (
        <div className={styles.subtopic}>
            {data.map((item, index) => {
                const originUrl = item.info.clientUrl || item.info.url || '';

                if (!originUrl) {
                    // 临时处理，将没有链接的删除
                    return undefined;
                }
                const url = isShare ? originUrl.replace(/https:\/\/([a-z])+\./, 'https://ishare.') : originUrl;

                return (
                    <div
                        key={index}
                        onClick={(e) => {
                            if (!handleCallUp(e)) {
                                if (inApp) {
                                    return Grounds.jumpInNative(item.info);
                                }

                                location.href = reLocation(`${url}${isVivo ? '?vivoback=true' : ''}`);
                            }
                        }}>
                        <img src={item.avatar} alt="" />
                        <span>{item.info.title}</span>
                    </div>
                );
            })}
        </div>
    );
});

export const HeaderBanner = errorBoundary(({ content, handleCallUp }) => {
    const { bannerAdUrl, isShare, docData, bannerAdImg, isVivo } = content;
    const { newBannerImg, bannerImgDisplay } = content.docData;
    const showSlideCard = docData.slideDisplay && docData.slideData && docData.slideData.data.length;
    const isBlankTop =
        (!bannerAdImg && !docData.bannerImg && !newBannerImg) || (!bannerImgDisplay && !newBannerImg && !bannerAdImg);
    const blankNoSlide = isBlankTop && !showSlideCard;

    return (
        <div
            className={`${styles.banner} ${
                showSlideCard || newBannerImg ? styles.banner_width_slide : styles.banner_no_slide
            } ${isBlankTop ? styles.blank_banner : null} ${blankNoSlide ? styles.blankNoSlide_banner : null} ${
                bannerImgDisplay && !isBlankTop ? styles.bigBanner : null
            }`}>
            <a href={bannerAdUrl} className={`${showSlideCard ? styles.showSlideCard : null}`}>
                {isVivo ? <img className={styles.logo} src={require('../assets/logo.png')} /> : null}
                <div
                    className={`${styles.content_header_mask} ${
                        !newBannerImg && !showSlideCard ? styles.content_header_mask_fix : null
                    }`}
                    style={{
                        backgroundImage: `url(${
                            bannerImgDisplay ? docData.bannerImg || bannerAdImg : bannerAdImg || newBannerImg
                        })`,
                    }}
                />
                <div className={styles.content_header}>
                    {!bannerImgDisplay ? <div className={styles.content_title}>{docData.title}</div> : null}
                    {docData && !bannerImgDisplay && docData.introDisplay === 1 ? (
                        <div
                            className={`${styles.content_desc} ${
                                bannerAdImg && !newBannerImg && !showSlideCard ? styles.content_desc_ad_fix : null
                            }`}>
                            <span>{docData.introduction}</span>
                        </div>
                    ) : (
                        ''
                    )}
                    {bannerAdImg && !bannerImgDisplay ? (
                        <div className={styles.bannerAd_icon}>
                            <img src={require('../assets/ad.png')} alt="" />
                        </div>
                    ) : null}
                    {/* {showSlideCard ? <SlideCard content={docData.slideData} isShare={isShare} /> : null} */}
                    {showSlideCard ? (
                        <NewSlideCard
                            content={docData.slideData.data}
                            isShare={isShare}
                            isVivo={isVivo}
                            handleCallUp={handleCallUp}
                        />
                    ) : null}
                </div>
            </a>
        </div>
    );
});

export const CallUpTip = errorBoundary(({ content, close }) => {
    const client = content.isVideoShare ? 'videoApp' : 'newsApp';
    const downloadVal = content.isVideoShare
        ? {}
        : {
              download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1429035725136',
              downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=2905',
          };
    const staticHandler = () => {
        callApp({
            client,
            docType: 'topic3',
            pid: content.base62Id,
            kind: 'inter|other_in_sf01',
            noKindFrom: 1,
            download: downloadVal.download,
            downloadAd: downloadVal.downloadAd,
        });
    };

    return (
        <div className={styles.calluptip}>
            <div className={styles.content}>
                {!content.isVideoShare && <div>前往凤凰新闻APP查看原文，体验更佳！</div>}
                {content.isVideoShare && <div>前往凤凰视频APP查看原文，体验更佳！</div>}
                <div className={styles.btns}>
                    <div onClick={() => close()}>取消</div>
                    <div onClick={() => staticHandler()}>前往</div>
                </div>
            </div>
        </div>
    );
});

TimeLine.propTypes =
    Category.propTypes =
    ViewPoint.propTypes =
    TopicComment.propTypes =
    BottomComment.propTypes =
    SubTitle.propTypes =
    HeaderBanner.propTypes =
        {
            content: PropTypes.object.isRequired,
        };
